import { call, getContext, select } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { checkPublish as checkPublishRequest, TCheckPublishResult } from '../../../../services/checkPublish';
import { IAppState } from '../../../types';
import { ITelemetryService } from '../../../../types/telemetryService';
import { getCheckPublishParams } from './utils';
import { ICheckPublishTermSchema } from '../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { selectConfigValue } from '../../../../selectors/config';
import {
  selectDynamicPricingParameters,
  selectLocationsFromAddress,
  selectOfferCoordinatesWithFallback,
} from '../../../../selectors/offer';
import { selectPlacingMoneySource } from '../../../../selectors/publishTerms';

export function* checkPublish(terms: Array<ICheckPublishTermSchema>) {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');
  const telemetryService: ITelemetryService = yield getContext('telemetryService');
  const state: IAppState = yield select();

  const locationPath = selectLocationsFromAddress(state);
  const coordinates = selectOfferCoordinatesWithFallback(state);
  const moneySource = selectPlacingMoneySource(state);
  const extraData = selectDynamicPricingParameters(state);

  const { offer, checkoutInfo } = state;

  const parameters = getCheckPublishParams({
    offer,
    locationPath,
    checkoutInfo,
    terms,
    isServiceChanged: false,
    coordinates,
    moneySource,
    extraData,
  });

  const subdomain = selectConfigValue('subdomain', state);

  const result: Promise<TCheckPublishResult> = yield call(checkPublishRequest, {
    httpApi,
    logger,
    telemetryService,
    parameters,
    subdomain,
  });

  return result;
}
